<div class="LoaderWrap" [hidden]="!loading">
    <div class="spinnerWrap">
        <div class="spinner"></div>
    </div>
</div>
